import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import GroupChatInfoContent from "./GroupChatInfoContent";
import { GroupChatInfoContextProvider } from "../../../provider/chats/chats/group_chat_info/GroupChatInfoContextProvider";

const GroupChatInfoScreen = () => {
  return (
    <GroupChatInfoContextProvider>
      <Scaffold appBarTitle={``} isModal={true}>
        <GroupChatInfoContent viewType="modal" />
      </Scaffold>
    </GroupChatInfoContextProvider>
  );
};

export default GroupChatInfoScreen;
